<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
  <h5>Signin with Google to access the Firebase database</h5>
  <br>
  <div class="row">
    <div class="col-md-6">
      <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
    </div>
  </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
  <h3 style="display:inline">{{action}} Exercise</h3>

  <i class="bi bi-question-circle" style="font-size: 1.5em;margin-left:20px;color:gray" (click)="showinfo = !showinfo"></i>
  <button class="btn btn-secondary" style="float:right;margin-right:20px;margin-top:10px" (click)="refresh()">Refresh</button>
  <div *ngIf="showinfo" style="margin:20px;padding:20px;background-color:lightgray;border:solid 1px gray">
    An exercise is an implementation of a scenario. It adds the teacher, the start date and a unique id.
    <br>
    The unique id is send to all students for the exercise. Without the id, students cannot crash the course.<br>
    <b>Note</b>: Dynamic player data is synchronized with all other players (browser clients) and therefore kept very small.<br>
    <b>Note</b>: The list of players in the dynamic section and the static section should be the same.
  </div>

  <div class="row">
    <div class="col-md-4">
      <div class="row">
        <div class="col-md-6">
          <sa-label [title]="'exerciseid'" [(text)]="exerciseid"></sa-label>
          <sa-input-text [(text)]="exercise.name" [title]="'name' "></sa-input-text>
          <sa-select [(Id)]="scenarioId" [title]="'scenarioId'" [options]="scenarios"></sa-select>
        </div>
        <div class="col-md-6">
          <sa-label [title]="'startdate'" [(text)]="exercise.startdate"></sa-label>
          <sa-input-text [(text)]="exercise.organization" [title]="'Organization' "></sa-input-text>
          <sa-input-text [(text)]="exercise.teacher" [title]="'teacher' "></sa-input-text>
        </div>
      </div>

      <br>
      <button class="btn btn-primary" (click)="updateExercise()">Update</button>
    </div>
    <div class="col-md-1"></div>
    <div class="col-md-6">
      <h3>Dynamic Player Data</h3>
      {{dynamicPlayerList.length}} Players
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Orientation</th>
            <th>Position</th>
            <th>Player State</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dynamicPlayerList">
            <td>{{item.id }}</td>
            <td>{{item.orientation | json}}</td>
            <td>{{item.position | json}}</td>
            <td>{{item.playerState}}</td>
            <td> <button class="btn btn-warning btn-sm" (click)="removePlayerDynamic(item)">Remove Player</button> </td>
          </tr>
        </tbody>
      </table>
      <h3>Static Player Data</h3>
      {{staticPlayerList.length}} Players
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>meshFileName</th>
            <th>role</th>
            <th>monitor</th>
            <th>dateTimeCreated</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of staticPlayerList">
            <td>{{item.id }}</td>
            <td>{{item.meshFileName}}</td>
            <td>{{item.role}}</td>
            <td>{{item.monitor}}</td>
            <td>{{item.dateTimeCreated}}</td>
            <td> <button class="btn btn-warning btn-sm" (click)="removePlayerStatic(item)">Remove Player</button> </td>
          </tr>
        </tbody>
      </table>

    </div>
    <button class="btn btn-primary" (click)="showExerciseJson = !showExerciseJson" style="margin-top:20px;">
      {{showExerciseJson ? 'Hide' : 'Show'}} Exercise JSON
    </button>
    <pre *ngIf="showExerciseJson">{{exercise | json}}</pre>
  </div>
</div>